<div class="w-full rounded-full  overflow-hidden" [ngClass]="secondColorClass">
  <div [ngClass]="singleColor ? 'bg-primary' :{
              'bg-[#F79400]': progress < 70,
              'bg-[#317756]': progress >= 70
            }" [style.height.px]="10" [style.width.%]="progress"></div>
</div>